"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var DialogActionButtons = function (_a) {
    var actionButtons = _a.actionButtons;
    if (!actionButtons)
        return null;
    return (react_1.default.createElement(DialogActions_1.default, null, actionButtons));
};
exports.default = DialogActionButtons;
